import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UsuarioPermissaoService } from '@services/usuario-permissao.service';
import { take } from 'rxjs/operators';
import { DadosEmpresaService } from 'src/app/services/dados-empresa.service';
import { SuccessGenericoComponent } from '../../../components/success-generico/success-generico.component';
import { LoadingGenericoComponent } from '../../../components/loading-generico/loading-generico.component';
import { ConfirmaExclusaoComponent } from '../confirma-exclusao/confirma-exclusao.component';
import { ErrorGenericoComponent } from '../../../components/error-generico/error-generico.component';
import { SelectComponent } from '../../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AsyncPipe } from '@angular/common';
import { CamelCasePipe } from '../../../pipes/camel-case.pipe';
import { UsuarioPermissaoPipe } from '../../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-dados-empresa-contatos',
    templateUrl: './dados-empresa-contatos.component.html',
    styleUrls: ['./dados-empresa-contatos.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SuccessGenericoComponent, LoadingGenericoComponent, ConfirmaExclusaoComponent, ErrorGenericoComponent, SelectComponent, NgxPaginationModule, RouterLink, AsyncPipe, CamelCasePipe, UsuarioPermissaoPipe]
})
export class DadosEmpresaContatosComponent implements OnInit {
  public idEmpresaLogada: string = localStorage.idEmpresaLogada;
  public dadosContato: any = null;
  public contatosPorPagina = `6`;
  public paginaContato = 1;
  public idContatoASerExcluido: number;

  // MANIPULAÇÃO DE ALERTS
  public alertConfirmacao = false;
  public alertSucesso = false;
  public alertLoading = false;
  public alertError = false;

  constructor(
    private readonly service: DadosEmpresaService,
    public rota: Router,
    public usuarioPermissaoService: UsuarioPermissaoService
  ) {}

  ngOnInit(): void {
    if (
      sessionStorage.DadosEmpresaContatosPagina &&
      sessionStorage.DadosEmpresaContatosQtdePorPagina
    ) {
      this.paginaContato = sessionStorage.DadosEmpresaContatosPagina;
      this.contatosPorPagina = sessionStorage.DadosEmpresaContatosQtdePorPagina;
      sessionStorage.removeItem('DadosEmpresaContatosPagina');
      sessionStorage.removeItem('DadosEmpresaContatosQtdePorPagina');
    }

    this.consultaDadosEmpresa();
  }

  consultaDadosEmpresa() {
    this.dadosContato = null;

    this.service.getDadosEmpresa(this.idEmpresaLogada)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if (response.status === 'OK') {
          if (response.response.contatos === null) {
            this.dadosContato = undefined;
          } else {
            this.dadosContato = response.response.contatos;
          }
        } else {
          this.dadosContato = false;
        }
      },
      error: (error: any) => {
        this.dadosContato = false;
        console.error(error);
      }
    });
  }

  // PASSO 1 - MOSTRA O ALERT DE CONFIRMAÇÃO PERGUTANDO SE DESEJA EXCLUIR
  confirmarExclusaoContato(idContato: number) {
    this.idContatoASerExcluido = idContato;
    this.alertConfirmacao = true;
  }

  // PASSO 2 - CASO TENHA CONFIRMADO A EXCLUSÃO NO ALERT, AI VEM PRA ESSE PASSO
  excluirContato() {
    this.alertLoading = true;
    this.service
      .deleteContato(this.idEmpresaLogada, this.idContatoASerExcluido)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.alertLoading = false;
          if (response.status === 'OK') {
            this.alertSucesso = true;
          } else {
            this.alertError = true;
          }        
        },
        error: (error: any) => {
          console.error(error);
          this.alertError = true;
        }
      });
  }

  fecharAlertConfirmacao(evento: string) {
    // Se clicar no botão de CONFIRMAR ele chama a função pra excluir
    if (evento === 'Confirmar') {
      this.alertConfirmacao = false;
      this.excluirContato();
    } else {
      // Se não apenas fecha o alert de confirmação e não faz nada
      this.alertConfirmacao = false;
    }
  }

  // Fechar o alerta de sucesso, clicando no botão OK
  fecharAlertSucesso(evento: string) {
    this.consultaDadosEmpresa();
    this.alertSucesso = false;
  }

  // Fechar o alerta de erro, clicando no botão OK
  fecharAlertError(evento: string) {
    this.alertError = false;
  }

  // REDIRECIONAR PARA A PÁGINA DE CONTATO
  editarContato(idContato: number) {
    sessionStorage.DadosEmpresaContatosPagina = this.paginaContato;
    sessionStorage.DadosEmpresaContatosQtdePorPagina = this.contatosPorPagina;
    sessionStorage.idContatoEditando = idContato;
    this.rota.navigate(['editar-contato/' + idContato]);
  }

  onContatosPorPaginaChange (value : string) {
    this.contatosPorPagina = value;
    this.paginaContato = 1;
  }
}
